import Page from "flarum/components/Page";
import AboutHeader from "../../components/AboutContent/AboutHeader";
import AboutTeamMember from "../../components/AboutContent/AboutTeamMember";
import LoadingIndicator from "flarum/components/LoadingIndicator";

export default class TeamPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    // Send history push
    app.history.push("aboutTeam");

    this.bodyClass = "App--AboutPage";

    app.setTitle("Team KVS");

    //this.loading = true;
    //this.team = [];

    this.getTeam();
  }

  // Load data
  getTeam() {
    const preloadedData = app.data.apiDocument || window.devNLHomeData;

    if (preloadedData) {
      // We must wrap this in a setTimeout because if we are mounting this
      // component for the first time on page load, then any calls to m.redraw
      // will be ineffective and thus any configs (scroll code) will be run
      // before stuff is drawn to the page.
      app.data.apiDocument = null;

      setTimeout(this.show.bind(this, preloadedData), 0);
    } else {
      this.reload();
    }
  }

  reload() {
    this.loading = true;

    app
      .request({
        method: "GET",
        url: `${app.forum.attribute("apiUrl")}/about/team`,
      })
      .then((data) => this.show(data));
  }

  show(data) {
    this.team = app.store.pushPayload(data);
    this.loading = false;
    m.redraw();
  }

  view() {
    return (
      <div className={"Site-AboutPage"}>
        <div className={"container"}>
          <AboutHeader selected={"team"} />

          <div className={"content-box content-padding"}>
            <p>
            Chúng tôi đam mê phát triển dưới mọi hình thức, các thành viên trong nhóm luôn duy trì nền tảng này chạy ở chế độ nền. Nhóm này kiểm duyệt nền tảng và hỗ trợ các thành viên giải đáp thắc mắc.
            </p>
            <p>
            Nếu bạn có bất kỳ câu hỏi hoặc phản hồi nào, vui lòng nói chuyện với một trong các thành viên trong nhóm của chúng tôi.
            </p>
          </div>

          {/*this.loading && <LoadingIndicator size={"large"} />*/}

          {/* Team DevNL 
          <div className={"Team-Cards"}>
            {this.team.length > 0 &&
              this.team.map((user) => <AboutTeamMember user={user} />)}
          </div>*/}
          <div class="Team-Cards">
            <a href="/u/KhatVongSong" class="content-box has-hover About-team-member">
                <img class="Avatar " loading="lazy" src="https://khatvongsong.vn/assets/avatars/wBUDFxu127L39n0P.png" alt="" />
                <h3>KVS<span class="UserCard-lastSeen"><i class="fas fa-circle"></i></span></h3>
                <p class="team-bio">Tôi là KVS, người sáng lập KVS.
                </p>
                <p class="discussion-stats">Thảo luận: 152 |
                    Bài viết
                       250
                </p><span class="team-registration-date">Thành viên kể từ ngày 10 tháng 2.2015</span>
            </a>
            <a href="/u/Jasper" class="content-box has-hover About-team-member">
                <img class="Avatar " loading="lazy" src="https://www.devnl.nl/assets/avatars/XSTAB6j7vkXrvE2C.png" alt="" />
                <h3>Jatpe<span class="UserCard-lastSeen"><i class="fas fa-circle"></i></span></h3>
                <p class="team-bio">Tôi là Jasper, nhà phát triển web và trò chơi.
                </p>
                <p class="discussion-stats">Thảo luận: 52 |
                    Bài viết
                       250
                </p><span class="team-registration-date">Thành viên kể từ ngày 10 tháng 2.2015</span>
            </a>
            <a href="/u/Pascal" class="content-box has-hover About-team-member">
                <img class="Avatar " loading="lazy" src="https://www.devnl.nl/assets/avatars/2ckUugTHXXBE2b1u.png" alt="" />
                <h3>Pascal<span class="UserCard-lastSeen"><i class="fas fa-circle"></i></span></h3>
                <p class="team-bio">Tôi là Pascal. Mong muốn học lập trình viên.Luôn luôn như vậy.
                </p>
                <p class="discussion-stats">Thảo luận: 11 |
                    Tin nhắn
                       108
                </p><span class="team-registration-date">Thành viên kể từ ngày 25 tháng 42017</span>
            </a>
            <a href="/u/Mitchel" class="content-box has-hover About-team-member">
                <img class="Avatar " loading="lazy" src="https://www.devnl.nl/assets/avatars/DTlT08Ih6gviJpVv.png" alt="" />
                <h3>Mitchell<span class="UserCard-lastSeen"><i class="fas fa-circle"></i></span></h3>
                <p class="team-bio">Lập trình viên full stack. Thích thử nghiệm các tính năng mới liên quan đến phát triển.
                </p>
                <p class="discussion-stats">Thảo luận: 36 |
                    Bài viết
                       267
                </p><span class="team-registration-date">Thành viên từ 13 tháng 22015</span>
            </a>
        </div>
        </div>
      </div>
    );
  }
}
